import Customization from "../customization";
import { Controller } from "@hotwired/stimulus";
import { ImageBlob } from "../customization/lib";

// Connects to data-controller="site-builder--custom-images--stock"
export default class extends Controller {
  static outlets = ["cropper"];

  connect() {
    this.imageType = document.body.dataset.imageType;
  }

  async apply({currentTarget}) {
    this.dataset = currentTarget.dataset;
    const url = this.dataset.fullImageUrl;
    const baseName = url.split("/").pop().split('?')[0];
    const nameWithExt = `${baseName}.jpeg`;

    await this.cropperOutlet.use(url, nameWithExt);
  }

  async render() {
    const originalUrl = this.cropperOutlet?.originalImageUrl;
    const fallbackUrl = this.dataset?.fullImageUrl;
    const resolvedUrl = originalUrl || fallbackUrl || "";
    const resolvedName = this.cropperOutlet?.filenameTarget?.textContent
      || resolvedUrl.split("/").pop().split('?')[0];

    if (this.cropperOutlet?.hasCropped()) {
      const image = await this.cropperOutlet.getImage({ name: resolvedName });
      const blob = new ImageBlob(image);
      const {url} = blob;
      window.blobs = { ...window.blobs, [this.imageType]: blob };

      Customization.serverUpdate({ [this.imageType]: { url, type: 'direct-upload', name: resolvedName } });
    } else {
      const containerSelector = `.image-container[data-site-builder--custom-images--actions-key-value="${this.imageType}"] .image-view`;
      const hiddenDiv = document.querySelector(`${containerSelector} .image-cropper-details`);
      const persistedDownloadUrl = hiddenDiv?.getAttribute('data-download-url');
      const downloadUrl = this.dataset?.image_download_location || persistedDownloadUrl;

      if (hiddenDiv && downloadUrl) {
        hiddenDiv.setAttribute('data-download-url', downloadUrl);
      }

      Customization.serverUpdate({ [this.imageType]: { url: resolvedUrl, type: 'stock', name: resolvedName, 'download-url': downloadUrl } });
    }
    this.dispatch('applied');
  }
}
